import { parse, format } from 'date-fns';
export class DateUtilsService {
    private static INVALID_DATE = 'Invalid Date';

    static formatEmployerDate(dateString: string): string {
        const date = new Date(dateString);

        if (date.toString() === this.INVALID_DATE) {
            throw Error('Date utils service: Not valid date');
        }
        const result = Intl.DateTimeFormat('uk-UA', {
            dateStyle: 'short',
            timeStyle: 'short',
        }).format(date);
        return result;
    }
}
